<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        errors: {}
    }
};
</script>

<template>
    <div class="text-danger">
        <ul class="list-unstyled pt-1">
            <li v-for="(e, idx) in errors" :key="idx" style="font-size: 13px;">
                {{ e }}
            </li>
        </ul>
    </div>
</template>

<style lang="scss"></style>
